import { Column, Row } from '~components/table-view';
import WorkerFocusAction from '~weekly-planner/components/WorkerFocusAction';

import DayDisplay from './DayDisplay';

const columnsFactory = (): Column[] => [
  {
    id: 'date',
    header: 'Day',
    type: 'custom',
    component: DayDisplay,
    componentProps: (row: Row) => ({ date: row.date }),
  },
  {
    id: 'user.full_name',
    header: 'Worker',
    type: 'text',
    deriveValue: (row) => row.user?.full_name ?? '',
  },
  {
    id: 'client.full_name',
    header: 'Client',
    type: 'text',
    deriveValue: (row) => row.client?.full_name ?? '',
  },
  {
    id: 'actions',
    header: '',
    type: 'custom',
    component: WorkerFocusAction,
    componentProps: (row: Row) => ({ userId: row.user?.id }),
  },
];

export default columnsFactory;
